<template>
  <router-view />
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "app",
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
}
</style>
